module.exports = __webpack_public_path__ + "img/cb07fd8b-e05f-49f7-913e-60a51c8f992a.8b4552e0.png";